import { discoverGameRowId, type GameRow } from "../../../../datagrid-configs/discoverGames";

/** Numeric row ids on the current page (for bulk-select header checkbox state). */
export function collectPageRowIds(items: GameRow[]): number[] {
	const pageRowIds: number[] = [];
	items.forEach((row) => {
		const id = discoverGameRowId(row);
		if (id !== null) {
			pageRowIds.push(id);
		}
	});
	return pageRowIds;
}
